import React, { FC } from "react"

import useTheme from "../../features/Theme/ThemeProvider"
import { IBodyProps, Text } from "./common"

export const Body1: FC<IBodyProps> = props => {
  const theme = useTheme()

  // noinspection RequiredAttributes
  return <Text {...props} type={theme.typography.body1} theme={theme} />
}
